export default __webpack_public_path__ + "static/media/photo-4.328a45a7.jpg";